import { Box, BoxProps, withStyles } from '@material-ui/core';
import { green } from 'globals/colors';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';
import React from 'react';

export const RowBox = withStyles(({ palette, spacing }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${palette.grey[200]}`,
    padding: spacing(3, 0),
    minWidth: 230,
  },
}))(({ isLast, ...otherProps }: BoxProps & { isLast?: boolean }) => (
  <Box {...otherProps} style={{ borderBottom: isLast ? 0 : undefined }} />
));

export const SingleMarker = withStyles(({ palette }) => ({
  root: {
    color: palette.grey[400],
    whiteSpace: 'nowrap',
    '& strong': {
      color: palette.common.black,
      fontWeight: 500,
    },
  },
}))(FsBodySmall);

export const Markers = withStyles(() => ({
  root: {},
}))(Box);

export const Avatar = withStyles(({ spacing }) => ({
  root: {
    width: spacing(5),
    height: spacing(5),
    overflow: 'hidden',
    background: green.V2,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))(({ color, ...otherProps }: BoxProps & { color?: string }) => (
  <Box {...otherProps} style={{ background: color || undefined }} />
));
